import React from "react";
import { Box, Grid, Stack, Typography } from "@mui/material";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { useParams } from "react-router-dom";
import { useGetContractManagementValuePercentageQuery } from "store/slices/apis/contractManagementDashboardSlice";

const ChangeOrderValue = (props) => {

  const { RaisedType } = props

  const { projectId } = useParams();
  const getRaisedType = (type) => {
    switch (type) {
      case "Claim Order Received":
        return "Change Order Received";

      case "Claim Order Raised":
        return "Change Order Raised";

      default:
        return "";
    }
  };

  const params = {
    projectId: projectId,
    raisedType: getRaisedType(RaisedType)
  }

  const { data, isLoading, isFetching } = useGetContractManagementValuePercentageQuery(params)


  const approvedValue =
    data?.data?.byStatus?.find(
      item => item.status === "Approved"
    )?.percentage || 0;

  console.log("approved", approvedValue)

  const rejectedValue =
    data?.data?.byStatus?.find(
      item => item.status === "Rejected"
    )?.percentage || 0;

  const pendingValue =
    data?.data?.byStatus?.find(
      item => item.status === "Pending Approval"
    )?.percentage || 0;

  const claimsData = [
    {
      label: "Approved",
      value: Number(approvedValue.toFixed(2)),
      color: "#C0CA33",
    },
    {
      label: "Pending Approval",
      value: Number(pendingValue.toFixed(2)),
      color: "#FF8D28",
    },
    {
      label: "Rejected",
      value: Number(rejectedValue.toFixed(2)),
      color: "#34C759",
    },
  ];


  const totalValue = Number(
    claimsData.reduce(
      (acc, item) => acc + parseFloat(item.value),
      0
    ).toFixed(2)
  );

  const chartOptions = {
    chart: {
      type: "solidgauge",
      height: 240,
    },

    title: null,

    pane: {
      center: ["50%", "67%"],
      size: "110%",
      startAngle: -120,
      endAngle: 120,
      background: [
        {
          outerRadius: "110%",
          innerRadius: "92%",
          backgroundColor: "#EEF0FF",
          shape: "arc",
        },
        {
          outerRadius: "91%",
          innerRadius: "73%",
          backgroundColor: "#F5F7FF",
          shape: "arc",
        },
        {
          outerRadius: "72%",
          innerRadius: "54%",
          backgroundColor: "#F5F7FF",
          shape: "arc",
        },
      ],
    },

    yAxis: {
      min: 0,
      max: 100,
      lineWidth: 0,
      tickPositions: [],
      overshoot: 90,
      wrap: false,
    },

    plotOptions: {
      solidgauge: {
        linecap: "round",
        stickyTracking: false,
        dataLabels: { enabled: false },
      },
    },

    series: [
      {
        name: claimsData[0].label,
        data: [
          {
            y: parseFloat(claimsData[0].value),
            color: claimsData[0].color,
            radius: "110%",
            innerRadius: "92%",
          },
        ],
      },
      {
        name: claimsData[1].label,
        data: [
          {
            y: parseFloat(claimsData[1].value),
            color: claimsData[1].color,
            radius: "91%",
            innerRadius: "73%",
          },
        ],
      },
      {
        name: claimsData[2].label,
        data: [
          {
            y: parseFloat(claimsData[2].value),
            color: claimsData[2].color,
            radius: "72%",
            innerRadius: "54%",
          },
        ],
      },
      {
        type: "pie",
        size: "40%",
        innerSize: "100%",
        data: [1],
        dataLabels: {
          enabled: true,
          useHTML: true,
          format: `
                <div style="text-align:center;">
                  <div style="font-size:20px;font-weight:700;color:#343A40;">${totalValue}%</div>
                  <div style="font-size:14px;color:#5F666C;font-weight:400;margin-top:-3px;">
                  of project Cost
                  </div>
                </div>
              `,
          distance: -40,
          borderWidth: 0,
          backgroundColor: "none",
          shadow: false,
        },
        enableMouseTracking: false,
      },
    ],

    credits: { enabled: false },
    exporting: { enabled: false },
  };

  return (
    <>
      <Grid container spacing={0}>
        <Grid size={12} sx={{ borderBottom: "1px solid #E5E5E5" }}>
          <Box
            sx={{
              p: "16px 16px 0px 16px",
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <Typography
              sx={{
                fontWeight: 600,
                fontSize: "20px",
                color: "#111216",
                lineHeight: "100%",
                fontFamily: "Outfit, sans-serif",
              }}
            >
              Change Order Value (As % of Total Project Cost)
            </Typography>
            {/* <IconButton sx={{ p: 0.5 }}>
                            <BsThreeDotsVertical color="#333436" size={18} />
                        </IconButton> */}
          </Box>
          <Grid size={12}>
            <Box sx={{ p: "16px 16px 16px 16px" }}>
              <Typography
                variant="body2"
                sx={{
                  fontFamily: "Outfit, sans-serif",
                  fontWeight: 300,
                  fontSize: "14px",
                  letterSpacing: "0px",
                  color: "#7D7F81",
                  lineHeight: "100%",
                }}
              >
                Track financial exposure of claims relative to overall project
                budget to mitigate potential cost overruns.
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </Grid>
      <Grid
        container
        spacing={3}
        alignItems={"center"}
        sx={{ p: 2, pb: 0, pt: 0 }}
      >
        <Grid size={{ xs: 12, md: 5 }}>
          <Stack
            spacing={2.4}
            sx={{
              pt: 1.5,
              pl: 1.5,
              pb: 1.5,
              maxHeight: "310px",
              minHeight: "150px",
              overflowY: "auto",
              justifyContent: "center",
            }}
          >
            {claimsData?.map((item, index) => (
              <Box
                key={index}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  border: "1px solid #EAEAEA",
                  borderRadius: "4px",
                  padding: "8px 10px",
                  backgroundColor: "#fff",
                }}
              >
                <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                  <Box
                    sx={{
                      width: 12,
                      height: 12,
                      borderRadius: "50%",
                      backgroundColor: item?.color,
                    }}
                  />
                  <Typography
                    sx={{
                      fontSize: "14px",
                      fontWeight: 400,
                      color: "#010814",
                      fontFamily: "Outfit, sans-serif",
                      lineHeight: "18px",
                      verticalAlign: "middle",
                    }}
                  >
                    {item?.label}
                  </Typography>
                </Box>

                <Box
                  sx={{
                    minWidth: 40,
                    height: 18,
                    borderRadius: "5px",
                    backgroundColor: "#E7E7EB",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: "11px",
                    fontWeight: 600,
                    color: "#433F5E",
                    fontFamily: "Outfit, sans-serif",
                  }}
                >
                  {item.value}%
                </Box>
              </Box>
            ))}
          </Stack>
        </Grid>
        <Grid size={{ xs: 12, md: 7 }}>
          <HighchartsReact highcharts={Highcharts} options={chartOptions} />
        </Grid>
      </Grid>
    </>
  );
};

export default ChangeOrderValue;
